import React from 'react';
import { Link } from 'react-router';
import { ArrowBack } from '@material-ui/icons';
import styles from './GoBack.scss';

const GoBack = ({ to, text }) => {
    return (
        <div className={styles.GoBack} data-cy="GoBack">
            <Link to={to} className={styles.GoBack__Link} onlyActiveOnIndex>
                <ArrowBack />
                <span className={styles.GoBack__TEXT} data-cy="GoBack-text">{text}</span>
            </Link>
        </div>
    );
};

export default GoBack;
